import React from "react";
import ReportsDetails from "./ReportsDetails";

const AuditorReport = () => {
  return <ReportsDetails />;
};

export default AuditorReport;
